import {useRoutePayload} from '@github-ui/react-core/use-route-payload'

import styles from '../marketplace.module.css'

import {Breadcrumbs, PageLayout, Text} from '@primer/react'
import type {ActionListing} from '../types'

export function ShowAction() {
  const payload = useRoutePayload<ActionListing>()

  return (
    <>
      <PageLayout>
        <PageLayout.Header>
          <Breadcrumbs>
            <Breadcrumbs.Item href="/marketplace">Marketplace</Breadcrumbs.Item>
            <Breadcrumbs.Item href="#" selected>
              {payload.name}
            </Breadcrumbs.Item>
          </Breadcrumbs>
        </PageLayout.Header>
        <PageLayout.Pane position="start">
          <div
            className={`rounded-3 bgColor-accent-emphasis ${styles['marketplace-logo']} ${styles['marketplace-logo--large']}`}
          >
            <img src="" alt="" className={styles['marketplace-logo-img']} />
          </div>
        </PageLayout.Pane>

        <PageLayout.Content as="div" width="medium">
          <div className="d-flex flex-items-center gap-2">
            <Text className="fgColor-muted">Copilot plugin</Text>
          </div>
          <h1>{payload.name}</h1>
        </PageLayout.Content>
      </PageLayout>
    </>
  )
}

try{ ShowAction.displayName ||= 'ShowAction' } catch {}